import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitle: {
		defaultMessage: 'Dashboard Wallboard',
		id: 'dashboard-wallboard.page-title',
		description: 'Page title of a Jira Dashboard page displaying in wallboard mode.',
	},
});
